import React from "react";
import ProductSwiper from './ProductSwiper'
import products from "./Dailyessentials"; // sample daily products

const DailyProd = () => {
  const filteredProducts = products; // or apply any filtering logic here

  return (
    <div>
   
      <ProductSwiper products={filteredProducts}  />
    </div>
  );
};

export default DailyProd;
